import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let person_id = useDataValue({
    viewPath: props.viewPath,
    context: 'payment_account',
    path: 'person_payment_account.payer_person.id',
  })

  let patient_person_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'person.id',
  })

  return {
    variables: {
      person_id,
      patient_person_id,
    },
  }
}
